import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from '../PlantDesignDetails.module.scss';
import { FormGroup, Input } from '@snsw/react-component-library';
import { isEmpty, isNumeric, validateExt } from 'shared/utils/Validation';
import { PlantDesignDetailsPage } from 'plantDesign/constants/plantDesignDetailsPage';

export const BuildingMaintenanceUnitDesignDetails = React.forwardRef((props, ref) => {
  const { safeWorkingLoad: saveSafeWorkingLoad = '', maxWorkingHeight: savedMaxWorkingHeight = '' } = props.value || {};

  const [safeWorkingLoad, setSafeWorkingLoad] = useState(saveSafeWorkingLoad);
  const [maxWorkingHeight, setMaxWorkingHeight] = useState(savedMaxWorkingHeight);

  const [showErrors, setShowErrors] = useState(false);
  const [errors, setErrors] = useState({});
  const [errorSummary, setErrorSummary] = useState([]);

  const PAGE_CONSTANTS = PlantDesignDetailsPage.buildingMaintenanceUnit;

  const validators = [
    {
      fieldName: 'safeWorkingLoad',
      fieldValue: safeWorkingLoad,
      isValid: isNumeric,
      errorMessage: (v) => (isEmpty(v) ? 'Please enter details' : 'Please enter only numeric value'),
    },
    {
      fieldName: 'maxWorkingHeight',
      fieldValue: maxWorkingHeight,
      isValid: isNumeric,
      errorMessage: (v) => (isEmpty(v) ? 'Please enter details' : 'Please enter only numeric value'),
    },
  ];

  if (ref) {
    ref.current = {
      validate: () => {
        const isValid = validateExt(validators, setErrors, setErrorSummary);
        setShowErrors(!isValid);
        return isValid;
      },
    };
  }

  useEffect(() => {
    const details = {
      safeWorkingLoad,
      maxWorkingHeight,
    };
    props.onChange(details);

    if (showErrors) validateExt(validators, setErrors, setErrorSummary);
  }, [safeWorkingLoad, maxWorkingHeight]);

  useEffect(() => {
    props.onErrorChange(errorSummary);
  }, [errorSummary]);

  return (
    <>
      <FormGroup
        id="safeWorkingLoad"
        label={PAGE_CONSTANTS.safeWorkingLoad.label}
        isRequired
        errorMessage={errors?.safeWorkingLoad?.errorMessage}
        hasError={showErrors && errors?.safeWorkingLoad?.invalid}
        className={styles.inputWithSuffix}
        margin={{ top: 'md' }}
      >
        <Input
          suffix={PAGE_CONSTANTS.safeWorkingLoad.suffix}
          onChange={(e) => setSafeWorkingLoad(e.target.value)}
          value={safeWorkingLoad}
          inputWidth="md"
        />
      </FormGroup>

      <FormGroup
        id="maxWorkingHeight"
        label={PAGE_CONSTANTS.maxWorkingHeight.label}
        isRequired
        errorMessage={errors?.maxWorkingHeight?.errorMessage}
        hasError={showErrors && errors?.maxWorkingHeight?.invalid}
        className={styles.inputWithSuffix}
        margin={{ top: 'md' }}
      >
        <Input
          suffix={PAGE_CONSTANTS.maxWorkingHeight.suffix}
          onChange={(e) => setMaxWorkingHeight(e.target.value)}
          value={maxWorkingHeight}
          inputWidth="md"
        />
      </FormGroup>
    </>
  );
});

BuildingMaintenanceUnitDesignDetails.displayName = 'BuildingMaintenanceUnitDesignDetails';

BuildingMaintenanceUnitDesignDetails.propTypes = {
  value: PropTypes.object,
  refData: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  onErrorChange: PropTypes.func.isRequired,
};
